import type { Color } from "@material-ui/core";
import type { PaletteOptions } from "@material-ui/core/styles/createPalette";

const GREY = {
  50: "#FAFAFA",
  100: "#F5F5F5",
  200: "#EEEEEE",
  300: "#E0E0E0",
  400: "#BDBDBD",
  500: "#9E9E9E",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
} satisfies Partial<Color>;

export const PALETTE = {
  primary: {
    main: "#004F71",
    light: "#266992",
    dark: "#00425F",
    contrastText: "#FFFFFF",
  },
  secondary: {
    main: "#C2EDFF",
    light: "#E0F6FF",
    dark: "#A4E3FF",
    contrastText: "#004F71",
  },
  background: { default: "#FFFFFF", paper: "#FFFFFF" },
  text: { primary: "#000000", secondary: "#878E95", disabled: GREY[600] },
  grey: GREY,
  success: {
    main: "#00D13B",
    light: "#00F545",
    dark: "#00CC3A",
    contrastText: "#FFFFFF",
  },
  brand: {
    main: "#00A0AF",
    light: "#00B8C9",
    dark: "#0096A4",
    contrastText: "#FFFFFF",
  },
  warning: {
    main: "#FFB81C",
    light: "#FFCE62",
    dark: "#F0A500",
    contrastText: "#000000",
  },
  error: {
    main: "#D23201",
    light: "#F43A01",
    dark: "#CB3001",
    contrastText: "#FFFFFF",
  },
  pink: {
    main: "#B55A72",
    light: "#C9778C",
    dark: "#A55067",
    contrastText: "#FFFFFF",
  },
  blue: {
    main: "#2D78C6",
    light: "#4685C7",
    dark: "#216AB6",
    contrastText: "#FFFFFF",
  },
  purple: {
    main: "#7434A7",
    light: "#894DB9",
    dark: "#681CA5",
    contrastText: "#FFFFFF",
  },
  black: {
    main: "#000000",
    light: "#000000",
    dark: "#000000",
    contrastText: "#FFFFFF",
  },
  disabled: {
    main: GREY[600],
    light: GREY[500],
    dark: GREY[700],
    contrastText: "#FFFFFF",
  },
  /** @deprecated - Delete with triage and use error */
  red: {
    main: "#D23201",
    light: "#F43A01",
    dark: "#CB3001",
    contrastText: "#FFFFFF",
  },
  /** @deprecated - Delete with triage */
  yellow: {
    main: "#FFB81C",
    light: "#FFCE62",
    dark: "#F0A500",
    contrastText: "#000000",
  },
  /** @deprecated - Delete with triage */
  orange: {
    main: "#D23201",
    light: "#F43A01",
    dark: "#CB3001",
    contrastText: "#FFFFFF",
  },
  /** @deprecated - Delete with triage */
  green: {
    main: "#D23201",
    light: "#F43A01",
    dark: "#CB3001",
    contrastText: "#FFFFFF",
  },
} satisfies PaletteOptions;
